// axios的二次封装
import axios from "axios"

const request = axios.create({
  // baseURL: "https://matchapi.gusto.cn/api",//正式服地址
  baseURL: "https://matchdevapi.gusto.cn/api",//测试服地址
  // baseURL: "http://localhost:10008/api/",//本地地址
})

// 请求拦截器
// request.interceptors.request.use((config) => {
//     const tokenStr = localStorage.getItem("eventAdminToken");
//     if (tokenStr) {
//       config.headers.gustoToken=tokenStr
//     }
//   return config
// })

// 响应拦截器
request.interceptors.response.use(
  (res) => {
      return res.data;
  },
  (error) => {
    try { 
    }
    catch (error) { 
      console.log(error);
      return Promise.reject(new Error(error.message || "请求失败"));
    }
  }
);

export default request